import { useEffect, useState } from 'react';
import { parseExpression } from 'cron-parser';
import { isValidCron } from 'cron-validator';

const CHUNK_SIZE = 100;

export function useGetCronJobs(
  expression: string,
  start: Date,
  end: Date,
): [Date[], { isLoading: boolean }] {
  const [cronJobs, setCronJobs] = useState<Date[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isValidCron(expression)) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    let shouldProcess = true;
    const jobs: Date[] = [];
    const iterator = parseExpression(expression, {
      currentDate: start,
      startDate: start,
      endDate: end,
    });

    const iterate = (): void => {
      let count = 0;

      while (shouldProcess && ++count <= CHUNK_SIZE) {
        try {
          const next = iterator.next();
          jobs.push(next.toDate());
        } catch (e) {
          // when we reach the last element of iterator, `next()` throws an exception
          setCronJobs(jobs);
          setIsLoading(false);
          return;
        }
      }

      if (shouldProcess) {
        requestAnimationFrame(iterate);
      }
    };

    requestAnimationFrame(iterate);

    return () => {
      shouldProcess = false;
    };
  }, [expression, start, end, setCronJobs]);

  return [!isValidCron(expression) ? [] : cronJobs, { isLoading }];
}
